import React from "react"
import { createRoot } from "react-dom/client"
import ParkingPage from "../parking/ParkingPage"
import "../parking/parking.css"
import { registerSW } from "virtual:pwa-register"

registerSW({
  immediate: true,
  onRegisteredSW(_swUrl, registration) {
    registration?.update()
  }
})

const rootElement = document.getElementById("root")

if (rootElement) {
  const root = createRoot(rootElement)
  root.render(
    <React.StrictMode>
      <ParkingPage />
    </React.StrictMode>
  )
}
